export const body_senses = [
  { char: '👀', name: 'Eyes', nameZh: '注視/亮點', keywords: ['look', 'see', 'watch'], hot: true },
  { char: '🧠', name: 'Brain', nameZh: '思考/知識', keywords: ['think', 'smart', 'idea'], hot: true },
  { char: '👂', name: 'Ear', nameZh: '傾聽/Podcast', keywords: ['listen', 'audio', 'sound'] },
  { char: '👅', name: 'Tongue', nameZh: '美味/品嚐', keywords: ['taste', 'eat', 'yummy'] },
  { char: '👃', name: 'Nose', nameZh: '氣味/香氛', keywords: ['smell', 'perfume', 'scent'] },
  { char: '👄', name: 'Mouth', nameZh: '說話/分享', keywords: ['talk', 'voice', 'lip'] },
  { char: '💪', name: 'Bicep', nameZh: '力量/堅持', keywords: ['strong', 'gym', 'power'], hot: true },
  { char: '🦶', name: 'Foot', nameZh: '腳步/實踐', keywords: ['walk', 'step', 'go'] },
  { char: '🖐️', name: 'Hand', nameZh: '擊掌/合作', keywords: ['highfive', 'stop', 'hand'] },
  { char: '👁️‍🗨️', name: 'Eye in Speech', nameZh: '見證/真相', keywords: ['truth', 'watch', 'eye'] },
  { char: '🦴', name: 'Bone', nameZh: '核心/基礎', keywords: ['core', 'body', 'health'] },
  { char: '🩸', name: 'Blood', nameZh: '熱血/生命力', keywords: ['red', 'power', 'life'] },
];